export class SolicitudCreditoEstado {
  id: number;
  nombre: string;
  color: string;


  constructor(id?: number, nombre?: string, color?: string) {
    this.id = id ?? null;
    this.nombre = nombre ?? '';
    this.color = color ?? '';
  }
}
